import Page from 'src/components/page/page';
import useLpEventsDetails from './lp-events-details.hook';
import { Alert, Box, Button, Container } from '@mui/material';
import { paths } from 'src/routes/paths';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import LpEventsForm from './components/lp-events-form';
import CloneBenefitsPreview from './components/clone-benefits-preview';
import CloneLeaveDialog from './components/clone-leave-dialog';

export default function LpEventsDetails() {
  const {
    isEdit,
    isClone,
    canClone,
    cloneDraft,
    cloneError,
    isLeaveDialogOpen,
    handleBack,
    cancelLeave,
    confirmLeave,
    pendingFields,
    methods,
    control,
    isSubmitting,
    isLoadingLpEventDetails,
    businessUnits,
    formValues,
    handleDropBannerImage,
    handleDropContentImage,
    handleDropRegisterPageBannerImage,
    handleDropRegisterPageContentImage,
    handleDropHomePageBannerImage,
    onSubmit,
    navigate,
  } = useLpEventsDetails();
  const defaultTitle = isEdit ? 'Editar Evento do Viva Visitante' : 'Cadastrar Evento do Viva Visitante';
  const title = isClone ? 'Copiar Evento do Viva Visitante' : defaultTitle;
  const hasCloneError = isClone && (!canClone || !!cloneError);
  const isLoading = isLoadingLpEventDetails || (isClone && !cloneDraft);

  return (
    <Page title={title}>
      <CloneLeaveDialog
        open={isLeaveDialogOpen}
        isSaving={isSubmitting}
        onCancel={cancelLeave}
        onConfirm={confirmLeave}
      />
      <Container maxWidth="xl">
        <HeaderBreadcrumbs heading={title} links={[]} sx={{ mb: 3 }} />
        {hasCloneError && (
          <Alert
            severity="error"
            action={<Button onClick={() => navigate(paths.dashboard.lpEventsList)}>Voltar</Button>}
          >
            {!canClone
              ? 'Apenas administradores com permissão de criação podem copiar eventos.'
              : cloneError}
          </Alert>
        )}
        {!hasCloneError && isLoading && (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        )}
        {!hasCloneError && !isLoading && (
          <LpEventsForm
            formValues={formValues}
            methods={methods}
            control={control}
            isEdit={isEdit}
            isClone={isClone}
            pendingCloneFields={pendingFields}
            cloneBenefits={
              cloneDraft && (
                <CloneBenefitsPreview
                  draft={cloneDraft}
                  startDate={formValues.startDate}
                  endDate={formValues.endDate}
                  canAutoScroll={pendingFields.length === 0}
                />
              )
            }
            isSubmitting={isSubmitting}
            businessUnits={businessUnits}
            onSubmit={onSubmit}
            onBack={handleBack}
            navigate={navigate}
            handleDropBannerImage={handleDropBannerImage}
            handleDropContentImage={handleDropContentImage}
            handleDropRegisterPageBannerImage={handleDropRegisterPageBannerImage}
            handleDropRegisterPageContentImage={handleDropRegisterPageContentImage}
            handleDropHomePageBannerImage={handleDropHomePageBannerImage}
          />
        )}
      </Container>
    </Page>
  );
}
